/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { Configuration, LogLevel } from "@azure/msal-browser";

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const isProduction = process.env.REACT_APP_IS_PRODUCTION;
export const isPalms = process.env.REACT_APP_IS_PALMS;
export const isLocal = window.origin.includes("localhost");

export const CLIENT_ID = !isPalms ? "605e8cf5-b957-479a-9019-6081f22cd2f9" : "093d7a45-9688-43c7-89ef-1d27ccdfecba";
export const SCOPE = !isPalms
  ? "api://a7d5d6df-f0f2-4f07-9526-e49bfa29b2bd/access_as_user"
  : "api://5a6cade0-5ee4-4307-a1a9-19838c4d16f3/access_as_user";
export const TENANT = !isPalms ? "48cdbe45-39e7-46db-9adb-e97333637016" : "c997dca4-14e8-4ffd-84ff-9c2477cd025f";
export const BASE_URL = !isPalms ? `https://business-api.sanmanuel.com` : `https://business-api.palms.com`;
export const SUBSCRIPTION_KEY = !isPalms ? "77c53cea7b9442e1bfb2562e74714a8b" : "429312d131954e22b1560b2f60fa906a";
export const SM_APPLICATION_ID = "BCA68598-EB7E-4598-83B7-B3A9C6627B61";
export const API_KEY = !isPalms ? "7c79b449851b4c7292ea2257c3405df4" : "429312d131954e22b1560b2f60fa906a";

export const msalConfig: Configuration = {
  auth: {
    clientId: CLIENT_ID,
    authority: `https://login.microsoftonline.com/${TENANT}`,
    redirectUri: `${window.location.protocol}//${window.location.host}/`,
  },
  cache: {
    cacheLocation: "sessionStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
        }
      },
    },
  },
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const graphLoginRequest = {
  scopes: ["User.Read"],
};
export const swrLoginRequest = {
  scopes: [SCOPE, "offline_access", "openid"],
};
export const loginRequest = {
  forceRefresh: true,
  scopes: swrLoginRequest.scopes,
};

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
};
